import request from '@/utils/request'

export function userInfoRegisterApi(data) {  // 用户注册
    return request({
        url: '/student/add',
        method: 'post',
        data
    })
}

export function sendVerifyCodeApi(data) {  // 发送验证码
    return request({
        url: '/student/verify_code',
        method: 'post',
        data
    })
}

export function userInfoLoginApi(data) {  // 用户登录
    return request({
        url: '/student/login',
        method: 'post',
        data,
        headers: {
            loding: 1
        }
    })
}

export function codeLoginApi(data) {  // 验证码登录
    return request({
        url: '/student/we_chat/login',
        method: 'post',
        data,
        headers: {
            loding: 1
        }
    })
}

export function updateUserinfoAPi(data) {  // 修改用户信息
    return request({
        url: '/user_info',
        method: 'put',
        data,
        headers: {
            loding: 2
        }
    })
}

export function updateUserPaddwordApi(data) {  // 修改用户密码
    return request({
        url: '/student/update_password',
        method: 'put',
        data,
        headers: {
            loding: 2
        }
    })
}

export function getMyUserinfoApi() {  // 获取自己的账号信息
    return request({
        url: '/user_info/get_account',
        method: 'get',
    })
}
